import { Card as AntCard, CardProps as AntCardProps } from "antd";
import { CSSProperties } from "react";
import { twMerge } from "tailwind-merge";
import α from "color-alpha";

type CardProps = AntCardProps & {
  glassmorphism?: boolean;
};

const cardStyleClassName =
  "overflow-hidden [&>.ant-card-head]:before:!block [&>.ant-card-head]:after:!block";

export default function Card({ glassmorphism, className, ...rest }: CardProps) {
  const card = (
    <AntCard
      className={twMerge(cardStyleClassName, className)}
      {...rest}
      data-test-id="card"
    />
  );

  if (glassmorphism) {
    const { style } = rest;

    return (
      <AntCard
        {...rest}
        data-test-id="card"
        style={
          {
            ...style,
            "--bg-card": α("white", 0.3),
            "--ant-color-border-secondary": "transparent",
          } as CSSProperties
        }
        className={twMerge(
          "backdrop-blur-md shadow-xl !bg-[var(--bg-card)]",
          cardStyleClassName,
          className,
        )}
      />
    );
  }

  return card;
}
